// ADD NEW COMPONENT TO CREATE NEW FIGHT
import { useState } from "react";
import BasicDropdown from "../ui/forms/dropdown/BasicDropdown";
import { getAllSeasons } from "../../services/seasonsAPI";
import {
  toGameOption,
  toLeagueOption,
  toPlayerOption,
  toSeasonOption,
  toTeamOption,
} from "../ui/forms/dropdown/ddLabels";
import { getDDLeagueNames } from "../../services/leaguesAPI";
import { AsyncDropdown } from "../ui/forms/dropdown/AsyncDropdown";
import { searchTeams } from "../../services/teamsAPI";
import { searchPlayers } from "../../services/playersAPI";
import { createFight } from "../../services/fightsAPI";
import { YouTubeVideoInput } from "../ui/forms/files/YouTubeVideoInput";
import { searchGames } from "../../services/gamesAPI";
import { toast } from "react-toastify";
import { Button } from "../ui/btns/Button";

const CreateNewFight = () => {
  const [isPending, setIsPending] = useState(false);
  // INITIAL DATA
  const initialState = {
    league: null,
    leagueName: "",
    leagueDescription: "",

    season: null,
    seasonTitle: "",

    awayTeam: null,
    awayTeamCity: "",
    awayTeamName: "",
    awayTeamDescription: "",

    homeTeam: null,
    homeTeamCity: "",
    homeTeamName: "",
    homeTeamDescription: "",

    player1: null,
    player1FirstName: "",
    player1LastName: "",
    player1NickName: "",
    player1Position: "",
    player1Height: "",
    player1Shoots: "",

    player2: null,
    player2FirstName: "",
    player2LastName: "",
    player2NickName: "",
    player2Position: "",
    player2Height: "",
    player2Shoots: "",

    fightDate: "",
    description: "",
    eventDescription: "",
    fightType: "",
    time: "00:00",
    tookPlaceAt: "",
    period: "",
    game: "",
  };
  const [formData, setFormData] = useState(initialState);
  const [youTubeUrl, setYouTubeUrl] = useState("");
  // ERRORS STATE FOR SHOWING ERRORS
  const [errors, setErrors] = useState({});

  // STATE FOR TOGGLING BETWEEN SELECT AND INPUTS (LIKE IF isNewLeague is false then show selec league if it is true then show inputs to create league like league name and desctipion)
  const [isNewGame, setIsNewGame] = useState(false);
  const [isNewLeague, setIsNewLeague] = useState(false);
  const [isNewSeason, setIsNewSeason] = useState(false);
  const [isNewHomeTeam, setIsNewHomeTeam] = useState(false);
  const [isNewAwayTeam, setIsNewAwayTeam] = useState(false);
  const [isNewPlayer1, setIsNewPlayer1] = useState(false);
  const [isNewPlayer2, setIsNewPlayer2] = useState(false);

  // FUNCITON TO HANDLE CHANGE IN INPUTS
  const handleChange = (input) => {
    if (input.target) {
      // Standard HTML input handling
      const { name, value } = input.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    } else {
      // react-select input handling, assuming input is { value, label }
      const { name, value } = input;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  const handleDropdownChange = (selectedOption, name) => {
    handleChange(
      selectedOption ? { name, value: selectedOption } : { name, value: null }
    );
  };

  // FUNCTION TO VALIDATE FORM BEFORE SEND REQUEST
  const validateForm = () => {
    const newErrors = {};
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/; // HH:MM format
    const seasonRegex = /^\d{4}-\d{4}$/; // YYYY-YYYY format

    if (isNewGame) {
      if (isNewLeague) {
        ["leagueName"].forEach((field) => {
          if (!formData[field]) {
            newErrors[field] = `League Name is required`;
          }
        });
      } else {
        if (!formData["league"]) newErrors["league"] = "Please Select league";
      }

      if (isNewSeason) {
        ["seasonTitle"].forEach((field) => {
          if (!formData[field]) {
            newErrors[field] = `Season title is required`;
          }
          // Validate season format
          if (formData.seasonTitle && !seasonRegex.test(formData.seasonTitle)) {
            newErrors.seasonTitle = "Season title must be in YYYY-YYYY format";
          }
        });
      } else {
        if (!formData["season"]) newErrors["season"] = "Please Select Season";
      }

      if (isNewHomeTeam) {
        ["homeTeamCity", "homeTeamName"].forEach((field) => {
          if (!formData[field]) {
            if (field === "homeTeamCity") {
              newErrors[field] = `Home Team City is required`;
            } else {
              newErrors[field] = `Home Team Name is required`;
            }
          }
        });
      } else {
        if (!formData["homeTeam"]) newErrors["homeTeam"] = "Please Select Home Team";
      }

      if (isNewAwayTeam) {
        ["awayTeamCity", "awayTeamName"].forEach((field) => {
          if (!formData[field]) {
            if (field === "awayTeamCity") {
              newErrors[field] = `Away Team City is required`;
            } else {
              newErrors[field] = `Away Team Name is required`;
            }
          }
        });
      } else {
        if (!formData["awayTeam"]) newErrors["awayTeam"] = "Please Select Away Team";
      }
    } else {
      if (!formData["game"]) newErrors["game"] = "Please Select Game";
    }

    if (isNewPlayer1) {
      ["player1FirstName", "player1LastName"].forEach((field) => {
        if (!formData[field]) {
          if (field === "player1FirstName") {
            newErrors[field] = `Player 1 First Name  is required`;
          } else {
            newErrors[field] = `Player 1 Last Name is required`;
          }
        }
      });
    } else {
      if (!formData["player1"]) newErrors["player1"] = "Please Select Player 1";
    }

    if (isNewPlayer2) {
      ["player2FirstName", "player2LastName"].forEach((field) => {
        if (!formData[field]) {
          if (!formData[field]) {
            if (field === "player2FirstName") {
              newErrors[field] = `Player 2 First Name  is required`;
            } else {
              newErrors[field] = `Player 2 Last Name is required`;
            }
          }
        }
      });
    } else {
      if (!formData["player2"]) newErrors["player2"] = "Please Select Player 2";
    }

    // Validate time format
    if (formData.time && !timeRegex.test(formData.time)) {
      newErrors.time = "Time must be in HH:MM format";
    }

    if (!formData["fightDate"]) {
      newErrors["fightDate"] = `Fight Date is required`;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  console.log(errors);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    // Convert formData to FormData
    const formDataToSubmit = new FormData();
    for (const key in formData) {
      if (formData.hasOwnProperty(key)) {
        const value = formData[key];

        // Check if the value is an object and has an 'id' property
        if (typeof value === "object" && value !== null && "value" in value) {
          formDataToSubmit.append(key, value.value); // Append only the 'id'
        } else {
          formDataToSubmit.append(key, value); // Append other values directly
        }
      }
    }
    formDataToSubmit.append("youTubeUrl", youTubeUrl);
    formDataToSubmit.append("isNewGame", isNewGame);
    formDataToSubmit.append("isNewLeague", isNewLeague);
    formDataToSubmit.append("isNewSeason", isNewSeason);
    formDataToSubmit.append("isNewHomeTeam", isNewHomeTeam);
    formDataToSubmit.append("isNewAwayTeam", isNewAwayTeam);
    formDataToSubmit.append("isNewPlayer1", isNewPlayer1);
    formDataToSubmit.append("isNewPlayer2", isNewPlayer2);

    setIsPending(true);
    try {
      let response = await createFight(formDataToSubmit);
      if (response?.success) {
        toast.success("Fight Created successfully");
        setFormData(initialState);
      } else {
        toast.error("Error while  creating a new fight", { autoClose: 5000 });
      }
      setIsPending(false);
    } catch (error) {
      toast.error("Error while  creating a new fight", { autoClose: 5000 });
      console.log(error);
      setIsPending(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center p-6">
      <h1 className="font-heading text-xl font-black uppercase tracking-wide text-flyers-orange mb-4">Create Fight</h1>
      <form
        onSubmit={handleSubmit}
        className="bg-flyers-charcoal border border-flyers-dark-gray p-6 rounded-lg w-[1000px] max-w-[90%]"
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full">
          {/* LEAGUE INPUTS */}
          {/* CHECK IF NEW LEAGUE IS SELECTED then SHOW LEAGUE NAME INPUT AND DESCRIPTION */}
          {/* CONDITIONAL RENDERING */}
          {/* SIMILAR TO ALL */}
          {isNewGame ? (
            <>
              {!isNewLeague ? (
                <div className="mb-4">
                  <div className="flex justify-between">
                    <label htmlFor="round" className="label">
                      League
                    </label>
                    <p
                      className="label-action"
                      onClick={() => {
                        setIsNewLeague(true);
                      }}
                    >
                      ADD NEW LEAGUE
                    </p>
                  </div>
                  <BasicDropdown
                    name="league"
                    placeholder="Select a League"
                    handleChange={handleDropdownChange}
                    isSearchable={true}
                    apiFunction={getDDLeagueNames}
                    toOptionLabel={toLeagueOption}
                  />
                  {errors?.league && <p className="error-text">{errors?.league}</p>}
                </div>
              ) : (
                <>
                  <div className="mb-4">
                    <div className="flex justify-between">
                      <label htmlFor="round" className="label">
                        League Name
                      </label>
                      <p
                        className="label-action"
                        onClick={() => {
                          setIsNewLeague(false);
                        }}
                      >
                        SELECT LEAGUE
                      </p>
                    </div>
                    <input
                      type="text"
                      id="leagueName"
                      name="leagueName"
                      value={formData.leagueName}
                      onChange={handleChange}
                      placeholder="Enter League Name"
                      className="input-new"
                    />
                    {errors?.leagueName && (
                      <p className="error-text">{errors?.leagueName}</p>
                    )}
                  </div>
                  <div className="mb-4">
                    <div className="flex justify-between">
                      <label htmlFor="round" className="label">
                        League Description (Optional)
                      </label>
                    </div>
                    <input
                      type="text"
                      id="leagueDescription"
                      name="leagueDescription"
                      value={formData.leagueDescription}
                      onChange={handleChange}
                      placeholder="Enter League Description"
                      className="input-new"
                    />
                  </div>
                </>
              )}

              {/* SEASON INPUTS */}
              {!isNewSeason ? (
                <div className="mb-4">
                  <div className="flex justify-between">
                    <label htmlFor="round" className="label">
                      Season
                    </label>
                    <p
                      className="label-action"
                      onClick={() => {
                        setIsNewSeason(true);
                      }}
                    >
                      ADD NEW SEASON
                    </p>
                  </div>
                  <BasicDropdown
                    name="season"
                    placeholder="Select a Season"
                    handleChange={handleDropdownChange}
                    isSearchable={true}
                    apiFunction={getAllSeasons}
                    toOptionLabel={toSeasonOption}
                  />
                  {errors?.season && <p className="error-text">{errors?.season}</p>}
                </div>
              ) : (
                <div className="mb-4">
                  <div className="flex justify-between">
                    <label htmlFor="round" className="label">
                      Season
                    </label>
                    <p
                      className="label-action"
                      onClick={() => {
                        setIsNewSeason(false);
                      }}
                    >
                      SELECT SEASON
                    </p>
                  </div>
                  <input
                    type="text"
                    id="seasonTitle"
                    name="seasonTitle"
                    value={formData.seasonTitle}
                    onChange={handleChange}
                    placeholder="Enter season"
                    className="input-new"
                  />
                  {errors?.seasonTitle && (
                    <p className="error-text">{errors?.seasonTitle}</p>
                  )}
                </div>
              )}

              {/* HOME TEAM INPUT */}

              {!isNewHomeTeam ? (
                <div className="mb-4">
                  <div className="flex justify-between">
                    <label htmlFor="round" className="label">
                      Home Team
                    </label>
                    <p
                      className="label-action"
                      onClick={() => {
                        setIsNewHomeTeam(true);
                      }}
                    >
                      ADD NEW HOME TEAM
                    </p>
                  </div>
                  <AsyncDropdown
                    id="homeTeam"
                    name="homeTeam"
                    apiFunction={searchTeams}
                    toOptionLabel={toTeamOption}
                    placeholder="Search Home Teams..."
                    isClearable={true}
                    handleChange={handleDropdownChange}
                    value={formData.homeTeam}
                  />
                  {errors?.homeTeam && <p className="error-text">{errors?.homeTeam}</p>}
                </div>
              ) : (
                <>
                  <div className="mb-4">
                    <div className="flex justify-between">
                      <label htmlFor="round" className="label">
                        Home Team City
                      </label>
                      <p
                        className="label-action"
                        onClick={() => {
                          setIsNewHomeTeam(false);
                        }}
                      >
                        SELECT HOME TEAM
                      </p>
                    </div>
                    <input
                      type="text"
                      id="homeTeamCity"
                      name="homeTeamCity"
                      value={formData.homeTeamCity}
                      onChange={handleChange}
                      placeholder="Enter Home Team City Name"
                      className="input-new"
                    />
                    {errors?.homeTeamCity && (
                      <p className="error-text">{errors?.homeTeamCity}</p>
                    )}
                  </div>
                  <div className="mb-4">
                    <div className="flex justify-between">
                      <label htmlFor="round" className="label">
                        Home Team Name
                      </label>
                    </div>
                    <input
                      type="text"
                      id="homeTeamName"
                      name="homeTeamName"
                      value={formData.homeTeamName}
                      onChange={handleChange}
                      placeholder="Enter Home Team Name"
                      className="input-new"
                    />
                    {errors?.homeTeamName && (
                      <p className="error-text">{errors?.homeTeamName}</p>
                    )}
                  </div>

                  <div className="mb-4">
                    <div className="flex justify-between">
                      <label htmlFor="round" className="label">
                        Home Team Description (Optional)
                      </label>
                    </div>
                    <input
                      type="text"
                      id="homeTeamDescription"
                      name="homeTeamDescription"
                      value={formData.homeTeamDescription}
                      onChange={handleChange}
                      placeholder="Enter Home Team  Description"
                      className="input-new"
                    />
                  </div>
                </>
              )}

              {/* AWAY TEAM INPUT */}

              {!isNewAwayTeam ? (
                <div className="mb-4">
                  <div className="flex justify-between">
                    <label htmlFor="round" className="label">
                      Away Team
                    </label>
                    <p
                      className="label-action"
                      onClick={() => {
                        setIsNewAwayTeam(true);
                      }}
                    >
                      ADD NEW AWAY TEAM
                    </p>
                  </div>
                  <AsyncDropdown
                    id="awayTeam"
                    name="awayTeam"
                    apiFunction={searchTeams}
                    toOptionLabel={toTeamOption}
                    placeholder="Search Away Teams..."
                    isClearable={true}
                    handleChange={handleDropdownChange}
                    value={formData.awayTeam}
                  />
                  {errors?.awayTeam && <p className="error-text">{errors?.awayTeam}</p>}
                </div>
              ) : (
                <>
                  <div className="mb-4">
                    <div className="flex justify-between">
                      <label htmlFor="round" className="label">
                        Away Team City
                      </label>
                      <p
                        className="label-action"
                        onClick={() => {
                          setIsNewAwayTeam(false);
                        }}
                      >
                        SELECT AWAY TEAM
                      </p>
                    </div>
                    <input
                      type="text"
                      id="awayTeamCity"
                      name="awayTeamCity"
                      value={formData.awayTeamCity}
                      onChange={handleChange}
                      placeholder="Enter Away Team City Name"
                      className="input-new"
                    />
                    {errors?.awayTeamCity && (
                      <p className="error-text">{errors?.awayTeamCity}</p>
                    )}
                  </div>
                  <div className="mb-4">
                    <div className="flex justify-between">
                      <label htmlFor="round" className="label">
                        Away Team Name
                      </label>
                    </div>
                    <input
                      type="text"
                      id="awayTeamName"
                      name="awayTeamName"
                      value={formData.awayTeamName}
                      onChange={handleChange}
                      placeholder="Enter away team  name"
                      className="input-new"
                    />
                    {errors?.awayTeamName && (
                      <p className="error-text">{errors?.awayTeamName}</p>
                    )}
                  </div>
                  <div className="mb-4">
                    <div className="flex justify-between">
                      <label htmlFor="round" className="label">
                        Away Team Description (Optional)
                      </label>
                    </div>
                    <input
                      type="text"
                      id="awayTeamDescription"
                      name="awayTeamDescription"
                      value={formData.awayTeamDescription}
                      onChange={handleChange}
                      placeholder="Enter away team  description"
                      className="input-new"
                    />
                  </div>
                </>
              )}
            </>
          ) : (
            <div className="mb-4">
              <div className="flex justify-between">
                <label htmlFor="round" className="label">
                  Game
                </label>
                <p
                  className="label-action"
                  onClick={() => {
                    setIsNewGame(true);
                  }}
                >
                  ADD NEW GAME
                </p>
              </div>

              <AsyncDropdown
                name="game"
                placeholder="Select a Game"
                handleChange={handleDropdownChange}
                isSearchable={true}
                apiFunction={searchGames}
                toOptionLabel={toGameOption}
              />

              {errors?.game && <p className="error-text">{errors?.game}</p>}
            </div>
          )}

          {/* PLAYER 1 INPUT */}

          {!isNewPlayer1 ? (
            <div className="mb-4">
              <div className="flex justify-between">
                <label htmlFor="round" className="label">
                  Player 1
                </label>
                <p
                  className="label-action"
                  onClick={() => {
                    setIsNewPlayer1(true);
                  }}
                >
                  ADD NEW PlAYER 1
                </p>
              </div>
              <AsyncDropdown
                name="player1"
                placeholder="Select a Player"
                handleChange={handleDropdownChange}
                isSearchable={true}
                apiFunction={searchPlayers}
                toOptionLabel={toPlayerOption}
              />
              {errors?.player1 && <p className="error-text">{errors?.player1}</p>}
            </div>
          ) : (
            <>
              <div className="mb-4">
                <div className="flex justify-between">
                  <label htmlFor="round" className="label">
                    Player 1 First Name
                  </label>
                  <p
                    className="label-action"
                    onClick={() => {
                      setIsNewPlayer1(false);
                    }}
                  >
                    SELECT PLAYER 1
                  </p>
                </div>
                <input
                  type="text"
                  id="player1FirstName"
                  name="player1FirstName"
                  value={formData.player1FirstName}
                  onChange={handleChange}
                  placeholder="Enter player 1 first name"
                  className="input-new"
                />
                {errors?.player1FirstName && (
                  <p className="error-text">{errors?.player1FirstName}</p>
                )}
              </div>
              <div className="mb-4">
                <div className="flex justify-between">
                  <label htmlFor="round" className="label">
                    Player 1 Last Name
                  </label>
                </div>
                <input
                  type="text"
                  id="player1LastName"
                  name="player1LastName"
                  value={formData.player1LastName}
                  onChange={handleChange}
                  placeholder="Enter player 1 last name"
                  className="input-new"
                />
                {errors?.player1LastName && (
                  <p className="error-text">{errors?.player1LastName}</p>
                )}
              </div>
              <div className="mb-4">
                <div className="flex justify-between">
                  <label htmlFor="round" className="label">
                    Player 1 Nick Name (Optional)
                  </label>
                </div>
                <input
                  type="text"
                  id="player1NickName"
                  name="player1NickName"
                  value={formData.player1NickName}
                  onChange={handleChange}
                  placeholder="Enter player 1 nickname"
                  className="input-new"
                />
              </div>
              <div className="mb-4">
                <div className="flex justify-between">
                  <label htmlFor="round" className="label">
                    Player 1 Position (Optional)
                  </label>
                </div>
                <input
                  type="text"
                  id="player1Position"
                  name="player1Position"
                  value={formData.player1Position}
                  onChange={handleChange}
                  placeholder="Enter player 1 position"
                  className="input-new"
                />
              </div>
              <div className="mb-4">
                <div className="flex justify-between">
                  <label htmlFor="round" className="label">
                    Player 1 Height(Optional)
                  </label>
                </div>
                <input
                  type="text"
                  id="player1Height"
                  name="player1Height"
                  value={formData.player1Height}
                  onChange={handleChange}
                  placeholder="Enter player 1 height"
                  className="input-new"
                />
              </div>
              <div className="mb-4">
                <div className="flex justify-between">
                  <label htmlFor="round" className="label">
                    Player 1 Shooting Preference (Optional)
                  </label>
                </div>
                <input
                  type="text"
                  id="player1Shoots"
                  name="player1Shoots"
                  value={formData.player1Shoots}
                  onChange={handleChange}
                  placeholder="Enter player 1 shooting preference"
                  className="input-new"
                />
              </div>
            </>
          )}

          {/* PLAYER 2 INPUT */}
          {!isNewPlayer2 ? (
            <div className="mb-4">
              <div className="flex justify-between">
                <label htmlFor="round" className="label">
                  Player 2
                </label>
                <p
                  className="label-action"
                  onClick={() => {
                    setIsNewPlayer2(true);
                  }}
                >
                  ADD NEW PLAYER 2
                </p>
              </div>
              <AsyncDropdown
                name="player2"
                placeholder="Select a Player"
                handleChange={handleDropdownChange}
                isSearchable={true}
                apiFunction={searchPlayers}
                toOptionLabel={toPlayerOption}
              />
              {errors?.player2 && <p className="error-text">{errors?.player2}</p>}
            </div>
          ) : (
            <>
              <div className="mb-4">
                <div className="flex justify-between">
                  <label htmlFor="round" className="label">
                    Player 2 First Name
                  </label>
                  <p
                    className="label-action"
                    onClick={() => {
                      setIsNewPlayer2(false);
                    }}
                  >
                    SELECT PLAYER 2
                  </p>
                </div>
                <input
                  type="text"
                  id="player2FirstName"
                  name="player2FirstName"
                  value={formData.player2FirstName}
                  onChange={handleChange}
                  placeholder="Enter player 2 first name"
                  className="input-new"
                />
                {errors?.player2FirstName && (
                  <p className="error-text">{errors?.player2FirstName}</p>
                )}
              </div>
              <div className="mb-4">
                <div className="flex justify-between">
                  <label htmlFor="round" className="label">
                    Player 2 Last Name
                  </label>
                </div>
                <input
                  type="text"
                  id="player2LastName"
                  name="player2LastName"
                  value={formData.player2LastName}
                  onChange={handleChange}
                  placeholder="Enter player 2 last name"
                  className="input-new"
                />
                {errors?.player2LastName && (
                  <p className="error-text">{errors?.player2LastName}</p>
                )}
              </div>
              <div className="mb-4">
                <div className="flex justify-between">
                  <label htmlFor="round" className="label">
                    Player 2 Nick Name (Optional)
                  </label>
                </div>
                <input
                  type="text"
                  id="player2NickName"
                  name="player2NickName"
                  value={formData.player2NickName}
                  onChange={handleChange}
                  placeholder="Enter player 2 nickname"
                  className="input-new"
                />
              </div>

              <div className="mb-4">
                <div className="flex justify-between">
                  <label htmlFor="round" className="label">
                    Player 2 Position (Optional)
                  </label>
                </div>
                <input
                  type="text"
                  id="player2Position"
                  name="player2Position"
                  value={formData.player2Position}
                  onChange={handleChange}
                  placeholder="Enter player 2 position"
                  className="input-new"
                />
              </div>
              <div className="mb-4">
                <div className="flex justify-between">
                  <label htmlFor="round" className="label">
                    Player 2 Height(Optional)
                  </label>
                </div>
                <input
                  type="text"
                  id="player2Height"
                  name="player2Height"
                  value={formData.player2Height}
                  onChange={handleChange}
                  placeholder="Enter player 2 height"
                  className="input-new"
                />
              </div>
              <div className="mb-4">
                <div className="flex justify-between">
                  <label htmlFor="round" className="label">
                    Player 2 Shooting Preference(Optional)
                  </label>
                </div>
                <input
                  type="text"
                  id="player2Shoots"
                  name="player2Shoots"
                  value={formData.player2Shoots}
                  onChange={handleChange}
                  placeholder="Enter player 2 Shooting Preference"
                  className="input-new"
                />
              </div>
            </>
          )}

          {/* DATE */}
          <div className="mb-4">
            <div className="flex justify-between">
              <label htmlFor="round" className="label">
                Date
              </label>
            </div>
            <input
              type="date"
              id="fightDate"
              name="fightDate"
              value={formData.fightDate}
              onChange={handleChange}
              className="input-new"
            />
            {errors?.fightDate && <p className="error-text">{errors?.fightDate}</p>}
          </div>

          {/* DESCRITON */}
          <div className="mb-4">
            <div className="flex justify-between">
              <label htmlFor="round" className="label">
                Description (Optional)
              </label>
            </div>
            <input
              type="text"
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="input"
            />
          </div>
          {/* EVENT DESCRIPTION */}
          <div className="mb-4">
            <div className="flex justify-between">
              <label htmlFor="round" className="label">
                Event Description (Optional)
              </label>
            </div>
            <input
              type="text"
              id="eventDescription"
              name="eventDescription"
              value={formData.eventDescription}
              onChange={handleChange}
              className="input"
            />
          </div>

          {/* FIGHT TYPE */}
          <div className="mb-4">
            <div className="flex justify-between">
              <label htmlFor="round" className="label">
                Fight Type (Optional)
              </label>
            </div>
            <input
              type="text"
              id="fightType"
              name="fightType"
              value={formData.fightType}
              onChange={handleChange}
              className="input"
            />
          </div>
          {/* Time */}
          <div className="mb-4">
            <div className="flex justify-between">
              <label htmlFor="round" className="label">
                Time (Optional)
              </label>
            </div>
            <input
              type="text"
              id="time"
              name="time"
              value={formData.time}
              onChange={handleChange}
              className="input"
            />
            {errors.time && <p className="error-text">{errors.time}</p>}
          </div>

          {/* Took Place */}

          <div className="mb-4">
            <div className="flex justify-between">
              <label htmlFor="round" className="label">
                Took Place At (Optional)
              </label>
            </div>
            <input
              type="text"
              id="tookPlaceAt"
              name="tookPlaceAt"
              value={formData.tookPlaceAt}
              onChange={handleChange}
              className="input"
            />
          </div>

          <div className="mb-4">
            <div className="flex justify-between">
              <label htmlFor="round" className="label">
                Period (Optional)
              </label>
            </div>
            <input
              type="text"
              id="period"
              name="period"
              value={formData.period}
              onChange={handleChange}
              className="input"
            />
          </div>

          {/* VIDEO LINK */}
          <div>
            <YouTubeVideoInput setYouTubeUrl={setYouTubeUrl} />
          </div>
        </div>
        <div className="text-center mt-5">
          <Button variant="primary" type="submit" className="mx-auto w-40" disabled={isPending}>
            Create Fight {isPending && "..."}
          </Button>
        </div>
      </form>
    </div>
  );
};
export default CreateNewFight;
